import React, {useContext, useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {useHistory, useLocation} from "react-router-dom";
import {useStore} from "../../../../../hooks/useStore";
import {AccountingRow} from "../../../../customer/customerHomePage/accountingRow/AccountingRow";
import {PanelLogo} from "../../../../_defaultComponents/PanelLogo/PanelLogo";
import {Link} from "react-router-dom";
import {
    Wrapper,
    TopSection,
    TopRightSection,
    BottomSection,
    LeftSection,
    RightSection,
    MenuButton,
    ButtonIcon,
    MobileMenuToggle,
    MobileMenu,
    CompanyInfo,
    MobileAccountSection,
    DropdownContainer,
    DropdownItem
} from "./CustomerMenuHeader.styles";
import profileIcon from "../../../../../public/images/profile-icon.svg";
import logoutIcon from "../../../../../public/images/logout-icon.svg";
import {Img} from "components/company/companyDetail/companyDetailStyles";
import GlobalSubCompanyInput from "components/_defaultComponents/GlobalSubCompanyInput/GlobalSubCompanyInput";
import {CreateDeliveryContext} from "components/createDeliveryRequest/CreateDeliveryRequest";
import createDeliveryIcon from "../../../../../public/images/create-delivery-icon.svg";
import accountingIcon from "../../../../../public/images/accounting-icon.svg";
import integrationIcon from "../../../../../public/images/integrations.svg";
import courierIcon from "../../../../../public/images/courier-icon.svg";
import {Dropdown} from "antd";
import {DownOutlined} from "@ant-design/icons";
import {getMainMenuItems} from "routes/routes";
import {getDedicatedCustomerMenuItems} from "routes/routes";
import {useTranslation} from "react-i18next";
import {isDedicatedIntegrationCustomer} from "utils/customerHelpers";

const DEFAULT_OPTIONS = {
    showLogo: true,
    showSideMenu: true,
    showLanguageSwitch: false
    // showWhatsappSupportButton: true
};

export const CustomerMenuHeader = observer(
    ({options = DEFAULT_OPTIONS, canShowCodPaymentMethodSelection}) => {
        const stores = useStore();
        const history = useHistory();
        const location = useLocation();
        const {t} = useTranslation();
        const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
        const hasCourierDailyOperations = stores?.meStore?.hasCourierDailyOperations || false;
        const isDedicatedIntegration = isDedicatedIntegrationCustomer(stores?.meStore);
        const noWidthForRightSection =
            location.pathname === "/musteri" || location.pathname === "/musteri/hesabim";

        const context = useContext(CreateDeliveryContext) || {};
        const {selectedCompany, selectedSubCompany} = context;
        const isPoolCompany = stores?.meStore?.isPoolCustomer;
        const isDedicatedCustomer = stores.meStore.isDedicatedCustomer;

        // canShowCodPaymentMethodSelection true ise cod sayfasında height 48px olsun
        const codOrAccounting = canShowCodPaymentMethodSelection
            ? false
            : location.pathname === "/musteri/kapida-odeme" ||
              location.pathname === "/musteri/muhasebe";

        const otherMenuItems = [
            ...(isDedicatedIntegration
                ? [
                      {
                          title: t("screens.requests", {ns: "common"}),
                          icon: accountingIcon,
                          path: "/musteri/taleplerim",
                          onClick: () => {
                              history.push("/musteri/taleplerim");
                              setIsMobileMenuOpen(false);
                          }
                      }
                  ]
                : []),
            {
                title: "Entegrasyonlar",
                icon: integrationIcon,
                path: "/musteri/entegrasyonlar",
                onClick: () => {
                    history.push("/musteri/entegrasyonlar");
                    setIsMobileMenuOpen(false);
                }
            },
            {
                title: "Kapıda Ödeme",
                icon: createDeliveryIcon,
                path: "/musteri/kapida-odeme",
                onClick: () => {
                    history.push("/musteri/kapida-odeme");
                    setIsMobileMenuOpen(false);
                }
            },
            ...(hasCourierDailyOperations
                ? [
                      {
                          title: "Kurye İşlemleri",
                          icon: courierIcon,
                          path: "/musteri/kurye-gunluk-islemleri",
                          onClick: () => {
                              history.push("/musteri/kurye-gunluk-islemleri");
                              setIsMobileMenuOpen(false);
                          }
                      }
                  ]
                : [])
        ];
        const accountMenuItem = {
            title: "Hesabım",
            icon: profileIcon,
            path: "/musteri/hesabim",
            onClick: () => {
                history.push("/musteri/hesabim");
                setIsMobileMenuOpen(false);
            }
        };

        const toLogout = async () => {
            await stores.appStore.setLoading(true);
            await stores.meStore.logout();
            await history.push("/login");
            await stores.appStore.setLoading(false);
            setIsMobileMenuOpen(false);
        };

        const isActivePath = path => {
            return location.pathname === path;
        };

        const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
        };

        const handleSelectSubcompany = value => {
            stores.meStore.setSelectedSubCompanyId(value);
        };

        const handleSubCompanySelect = React.useCallback(
            selectedSubCompany => {
                // CreateDeliveryContext'e alt firma bilgisini aktar
                if (context?.handleSelectPickupPoint) {
                    context.handleSelectPickupPoint({subCompanyId: selectedSubCompany._id});
                }
            },
            [context?.handleSelectPickupPoint]
        );
        const subCompanyOptionFilter = subCompany => {
            if (!selectedCompany) return true;
            return subCompany.companyId === selectedCompany._id.toString();
        };

        // Tek alt firma varsa ok işaretini gizle ve disabled yap
        const filteredSubCompanies =
            stores?.meStore?.subcompanies?.filter(subCompanyOptionFilter) || [];
        const shouldHideSuffixIcon = filteredSubCompanies.length === 1;
        const shouldDisable = filteredSubCompanies.length === 1;

        return (
            <Wrapper>
                {options.showLogo ? (
                    <TopSection>
                        <Link to={{pathname: "/musteri"}}>
                            <PanelLogo />
                        </Link>
                        <TopRightSection>
                            <CompanyInfo>
                                <Img
                                    className="desktop-only"
                                    src={stores?.meStore?.companies?.[0]?.photolink}
                                    data-testid="companyImage"
                                    style={{
                                        width: "35px",
                                        height: "35px",
                                        borderRadius: "50%",
                                        objectFit: "cover"
                                    }}
                                />
                                <MobileMenuToggle
                                    onClick={toggleMobileMenu}
                                    $isOpen={isMobileMenuOpen}
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </MobileMenuToggle>
                            </CompanyInfo>
                            <GlobalSubCompanyInput
                                data-testid="header_subCompanyInput"
                                onChange={handleSelectSubcompany}
                                value={stores.meStore.selectedSubCompanyId}
                                company={stores?.meStore?.companies?.[0]?._id}
                                optionFilter={subCompanyOptionFilter}
                                onSubCompanySelect={handleSubCompanySelect}
                                initialCall={true}
                                hideSuffixIcon={shouldHideSuffixIcon}
                                disabled={shouldDisable}
                            />
                            <MenuButton
                                className="desktop-only"
                                onClick={accountMenuItem.onClick}
                                $isActive={isActivePath(accountMenuItem.path)}
                            >
                                <ButtonIcon
                                    src={accountMenuItem.icon}
                                    alt={accountMenuItem.title}
                                    $isActive={isActivePath(accountMenuItem.path)}
                                />
                                {accountMenuItem.title}
                            </MenuButton>
                            <MenuButton className="desktop-only" onClick={toLogout} $isLogout>
                                <ButtonIcon src={logoutIcon} alt="Çıkış Yap" />
                                Çıkış
                            </MenuButton>
                        </TopRightSection>
                    </TopSection>
                ) : (
                    <></>
                )}

                {/* Mobile Menu */}
                <MobileMenu $isOpen={isMobileMenuOpen}>
                    <MobileAccountSection>
                        <MenuButton
                            onClick={accountMenuItem.onClick}
                            $isActive={isActivePath(accountMenuItem.path)}
                            $isMobile
                        >
                            <ButtonIcon
                                src={accountMenuItem.icon}
                                alt={accountMenuItem.title}
                                $isActive={isActivePath(accountMenuItem.path)}
                            />
                            {accountMenuItem.title}
                        </MenuButton>
                        <MenuButton onClick={toLogout} $isLogout $isMobile>
                            <ButtonIcon src={logoutIcon} alt="Çıkış Yap" />
                            Çıkış
                        </MenuButton>
                    </MobileAccountSection>
                </MobileMenu>

                {/* Desktop Bottom Section */}
                <BottomSection>
                    <LeftSection>
                        {!isPoolCompany && isDedicatedCustomer
                            ? getDedicatedCustomerMenuItems(history, setIsMobileMenuOpen).map(
                                  (item, index) => (
                                      <MenuButton
                                          key={index}
                                          onClick={item.onClick}
                                          $isActive={isActivePath(item.path)}
                                      >
                                          <ButtonIcon
                                              src={item.icon}
                                              alt={item.title}
                                              $isActive={isActivePath(item.path)}
                                          />
                                          {item.title}
                                      </MenuButton>
                                  )
                              )
                            : getMainMenuItems(stores, history, setIsMobileMenuOpen).map(
                                  (item, index) => (
                                      <MenuButton
                                          key={index}
                                          onClick={item.onClick}
                                          $isActive={isActivePath(item.path)}
                                      >
                                          <ButtonIcon
                                              src={item.icon}
                                              alt={item.title}
                                              $isActive={isActivePath(item.path)}
                                          />
                                          {item.title}
                                      </MenuButton>
                                  )
                              )}
                        {isPoolCompany && (
                            <Dropdown
                                overlay={
                                    <DropdownContainer>
                                        {otherMenuItems.map((item, index) => {
                                            const isActive = isActivePath(item.path);
                                            const hasBorder = index < otherMenuItems.length - 1;
                                            return (
                                                <DropdownItem
                                                    key={index}
                                                    onClick={item.onClick}
                                                    $isActive={isActive}
                                                    $hasBorder={hasBorder}
                                                >
                                                    <img src={item.icon} alt={item.title} />
                                                    {item.title}
                                                </DropdownItem>
                                            );
                                        })}
                                    </DropdownContainer>
                                }
                                trigger={["click"]}
                                placement="bottomLeft"
                            >
                                <MenuButton>
                                    Diğer
                                    <DownOutlined style={{marginLeft: "8px", fontSize: "12px"}} />
                                </MenuButton>
                            </Dropdown>
                        )}
                    </LeftSection>
                    {isPoolCompany && (
                        <RightSection
                            $noWidth={noWidthForRightSection}
                            $codOrAccounting={codOrAccounting}
                        >
                            <AccountingRow />
                        </RightSection>
                    )}
                </BottomSection>
            </Wrapper>
        );
    }
);
